/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_Multiview_ButtonInputs */



/**
* | output |
* | --- |
* | "Split Group" |
*
* @param {Split_Multiview_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_button = /** @type {((inputs?: Split_Multiview_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe divisé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Split Group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo diviso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделенная группа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo dividido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分割グループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विभाजित समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo dividido")
	return /** @type {LocalizedString} */ ("Split Group")
});